import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
// noinspection TypeScriptValidateTypes

export const routes: Routes = [
  {
    path: 'login',
    data : {
      page_title : 'Login'
    },
    loadChildren: 'app/pages/login/login.module#LoginModule'
  },
  {
    path: 'pages/dashboardSettings/triggers',
    data : {
      page_title : 'Triggers'
    },
    loadChildren: './triggers/trigger.module#TriggerModule'
  },
  {
    path: 'pages/dashboard/allDevices',
    data : {
      page_title : 'Dashboard'
    },
    loadChildren: './allDevices/allDevices.module#AllDevicesModule'
  },
  {
    path: 'pages/dashboard/deviceDetails/:id',
    data : {
      page_title : 'Device Summary'
    },
    loadChildren: 'app/pages/deviceDetails/deviceDetails.module#DeviceDetailsModule'
  },
  {
    path: 'pages/dashboard/dashboardMap',
    data : {
      page_title : 'Feeds and Alarms'
    },
    loadChildren: 'app/pages/dashboardMap/dashboardMap.module#DashboardMapModule'
  },
  {
    path: 'pages/dashboard/meteringDashboard',
    data : {
      page_title : 'Metering Dashboard'
    },
    loadChildren: 'app/pages/metering-dashboard/metering.module#MeteringDashboardModule'
  },
  {
    path: 'pages/dashboard/deviceAlerts',
    data : {
      page_title : 'Diagnostics'
    },
    loadChildren: 'app/pages/device-alerts/device-alerts.module#DeviceAlertsModule'
  },
  {
    path: 'pages/dashboardSettings/manageDevices',
    data : {
      page_title : 'Device Management'
    },
    loadChildren: 'app/pages/addDevice/addDevice.module#AddDeviceModule'
  },
  {
    path: 'pages/userSettings/userActivity',
    data : {
      page_title : 'User Activity'
    },
    loadChildren: 'app/pages/userActivity/userActivity.module#UserActivityModule'
  },
  {
    path: 'pages/userSettings/manageUsers',
    data : {
      page_title : 'User Management'
    },
    loadChildren: 'app/pages/userManagement/userManagement.module#userManagementModule'
  },
  {
    path: 'pages/accountSettings/profileSettings',
    data : {
      page_title : 'Profile Settings'
    },
    loadChildren: 'app/pages/profileSettings/profileSettings.module#ProfileSettingsModule'
  },
  {
    path: 'pages/dashboard/onemap',
    data : {
      page_title : 'One Map Dashboard'
    },
    loadChildren: 'app/pages/onemap/onemap.module#OnemapModule'
  },
  {
    path: 'pages/dashboard/gps',
    data : {
      page_title : 'GPS Dashboard'
    },
    loadChildren: 'app/pages/gpsTracker/gps.module#gpsModule'
  },
  {
    path: 'pages/billingInfo',
    data : {
      page_title : 'Billing Information'
    },
    loadChildren: 'app/pages/billing-info/billingInfo.module#BillingInfoModule'
  },
  {
    path: 'pages/accountSettings/changePassword',
    data : {
      page_title : 'Change Password'
    },
    loadChildren: 'app/pages/profileSettings/changePassword/changePassword.module#ChangePasswordModule'
  },
  {
    path: 'pages/customDashboard/:name',
    data : {
      page_title : 'Custom Dashboard'
    },
    loadChildren: 'app/pages/custom-dashboard/custom-dashboard.module#CustomDashboardModule'
  },
  {
    path: 'reset-password/uid/:uid/token/:token',
    loadChildren: 'app/pages/resetPassword/resetPassword.module#ResetPasswordModule'
  },
  {
    path: 'verify-email/:token',
    loadChildren: 'app/pages/verifyEmail/verifyEmail.module#verifyEmailModule'
  },
  {
    path: 'pages/:dashboardType/:dashboardPage/:token/org/:org/user/:user',
    loadChildren: 'app/pages/redirectPage/redirectPage.module#redirectPageModule'
  },
  {
    path: 'pages/:dashboardType/:dashboardPage/:deviceId/:token/org/:org/user/:user',
    loadChildren: 'app/pages/redirectPage/redirectPage.module#redirectPageModule'
  },
  {
    path: 'pages/:dashboardType/:token/org/:org/user/:user',
    loadChildren: 'app/pages/redirectPage/redirectPage.module#redirectPageModule'
  },

];

export const routing: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// ./src/app/pages/pages.routing.ts